import { AnimatePresence, motion } from "motion/react";
import React from "react";
import { DYNAMIC_ISLAND } from "../../../../config/dynamicIsland.configuration";
import { type DynamicIslandContentMotionWrapperProps } from "../../dynamicIsland.registry";
import { type DynamicIslandItinerarySummaryPayload } from "../../dynamicIsland.types";

/** Intra-variant session crossfade (same kind, different itinerary). */
const ITINERARY_SESSION_CROSSFADE = {
    "duration": 0.18,
    "ease":     "easeOut",
} as const;

/**
 * Motion wrapper for itinerary summary island content.
 * Crossfades when itineraryId changes; leg selection is handled via wrapLegItem.
 * Skips enter when the shell already animated a kind switch.
 *
 * @param props Wrapper props from the presence shell.
 * @returns Animated children.
 */
const DynamicIslandItinerarySummaryMotionWrapper: React.FC<
    DynamicIslandContentMotionWrapperProps<DynamicIslandItinerarySummaryPayload>
> = ( { animationKey, reducedMotion, skipEnterAnimation = false, children } ) => {
    const animationsEnabled = DYNAMIC_ISLAND.animations.enabled && !reducedMotion;

    if ( !animationsEnabled || skipEnterAnimation ) {
        return children;
    }

    return (
        <AnimatePresence mode="sync">
            <motion.div
                animate={{ "opacity": 1 }}
                className="h-full w-full"
                exit={{ "opacity": 0 }}
                initial={{ "opacity": 0 }}
                key={animationKey}
                transition={ITINERARY_SESSION_CROSSFADE}
            >
                {children}
            </motion.div>
        </AnimatePresence>
    );
};

export default DynamicIslandItinerarySummaryMotionWrapper;
